import Theme from '@adsk/alloy-react-theme';

export const labelStyle = {
  display: 'flex',
  paddingBottom: '8px',
  ...Theme.typography.labelSmall,
  color: Theme.colors.charcoal700,
};

export const requiredStyle = {
  color: Theme.colors.red500,
};

export const tooltipIconStyle = {
  marginLeft: '5px',
  color: Theme.colors.charcoal700,
};
